import React from 'react';
import { FRAME_COLOR } from '../costBenchmarkHelpers.js';
import PropTypes from 'prop-types';

const Axis = ({ ticks, scale, orientation, innerWidth, innerHeight }) => (
  <g className={`axis-${orientation}`}>
    {ticks.map((tick) => {
      const isX = orientation === 'x';
      return (
        <g key={`${orientation}-${tick}`} transform={isX ? `translate(${scale(tick)}, 0)` : `translate(0, ${scale(tick)})`}>
          <line 
            x2={isX ? 0 : innerWidth} 
            y2={isX ? innerHeight : 0} 
            stroke={FRAME_COLOR} 
          />
          <text
            x={isX ? 0 : -10}
            y={isX ? innerHeight + 25 : 0}
            dy={isX ? '0' : '0.32em'}
            textAnchor={isX ? 'middle' : 'end'}
            className="axis-custom"
          >
            {tick}
          </text>
        </g>
      );
    })}
  </g>
);

Axis.propTypes = {
  ticks: PropTypes.array,
  scale: PropTypes.func,
  orientation: PropTypes.string,
  innerWidth: PropTypes.number,
  innerHeight: PropTypes.number,
};

export default Axis;
